import client from '../api/client.js';
import { probeHub } from './hub.js';
import { useAuthStore } from '../store/authStore.js';

// ─── Encontrar la caja principal sin teclear nada ─────────────────────────────
//
// La caja principal le dice a la nube cada minuto en qué direcciones de la red
// local contesta (hub/src/cloud.js → anunciar). Aquí se le pregunta a la nube
// por las cajas vivas de este comercio y se prueban sus direcciones, todas a la
// vez; gana la primera que conteste y sea de este mismo comercio.
//
// Devuelve { url, name, id } o null si ninguna contesta desde esta red (otro
// WiFi, datos móviles, la caja apagada).
export async function buscarCajaPrincipal({ preferirId = null } = {}) {
  const r = await client.get('/pos/sync/hubs', { nube: true, timeout: 8000 });
  const cajas = r.data?.data ?? [];
  if (!cajas.length) return null;
  const miComercio = String(useAuthStore.getState().tenantId ?? '');
  // La que ya conocíamos primero: si el router le cambió la IP, es la misma caja.
  cajas.sort((a, b) => Number(b.hub_id === preferirId) - Number(a.hub_id === preferirId));

  const intentos = cajas.flatMap((caja) => (caja.urls ?? []).map(async (url) => {
    const { url: u, status } = await probeHub(url);
    if (status.tenantId && String(status.tenantId) !== miComercio) throw new Error('otro comercio');
    return { url: u, name: status.name ?? caja.name, id: status.id ?? caja.hub_id };
  }));
  if (!intentos.length) return null;
  try { return await Promise.any(intentos); } catch { return null; }
}

export const hayCajaPrincipal = async () => {
  try {
    const r = await client.get('/pos/sync/hubs', { nube: true, timeout: 8000 });
    return (r.data?.data ?? []).length > 0;
  } catch { return false; }
};
